<div class="season-passes-panel orders-panel">
    <div class="btns-filters">
        <div class="filters-left">
            <div class="buscador-event container-form d-flex align-items-center borderInput">
                <i class="fal fa-search search-icon pointer-in"></i>
                <input class="input-custom w-100" type="text" placeholder="Buscar por nombre, NIF o email"
                    [ngModel]="searchText" (input)="onSearch($any($event.target).value)">
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="seasonFilter !== ''" (click)="toggleSeasonDropdown()">
                    <i class="fal fa-calendar-range"></i>
                    <span>{{ seasonFilterLabel }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="seasonDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="seasonDropdownOpen">
                    <div class="filter-option" [class.selected]="seasonFilter === ''" (click)="selectSeasonFilter('')">Todas las temporadas</div>
                    <div class="filter-option" *ngFor="let s of seasons" [class.selected]="seasonFilter === s.id" (click)="selectSeasonFilter(s.id)">{{ s.name }}</div>
                </div>
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="productFilter !== ''" (click)="toggleProductDropdown()">
                    <i class="fal fa-tag"></i>
                    <span>{{ productFilterLabel }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="productDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="productDropdownOpen">
                    <div class="filter-option" [class.selected]="productFilter === ''" (click)="selectProductFilter('')">Todos los productos</div>
                    <div class="filter-option" *ngFor="let p of products" [class.selected]="productFilter === p.id" (click)="selectProductFilter(p.id)">{{ p.name }}</div>
                </div>
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="!isDefaultStatusFilter" (click)="toggleStatusDropdown()">
                    <i class="fal fa-signal-bars"></i>
                    <span>{{ statusFilterLabel }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="statusDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="statusDropdownOpen">
                    <div class="filter-option" *ngFor="let s of statusOptions" [class.selected]="statusFilter === s.value" (click)="selectStatusFilter(s.value)">{{ s.label }}</div>
                </div>
            </div>
            <button class="btn-clear" *ngIf="hasActiveFilters" (click)="clearFilters()">
                <i class="fal fa-xmark"></i> Limpiar
            </button>
        </div>
    </div>

    <div *ngIf="loadingPage" class="container-lottie">
        <div class="loading-container">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>

    <!-- Resumen de lo que hay en la lista filtrada -->
    <div class="orders-summary" *ngIf="loaded && !loadingPage && orders.length">
        <div class="summary-item">
            <span class="summary-label">Pedidos</span>
            <p class="summary-value">{{ totalOrders }}</p>
        </div>
        <div class="summary-item">
            <span class="summary-label">Pagados</span>
            <p class="summary-value">{{ paidCount }}</p>
        </div>
        <div class="summary-item">
            <span class="summary-label">Pendientes</span>
            <p class="summary-value">{{ pendingCount }}</p>
        </div>
        <div class="summary-item summary-item--total">
            <span class="summary-label">Total cobrado</span>
            <p class="summary-value">{{ totalCollected | number: '1.2-2' }} €</p>
        </div>
    </div>

    <!-- El listado llega paginado: al llegar al final de la tabla se pide la
         página siguiente (ver isScrolledInfinityView). -->
    <div #containerScroll class="bg-transparent" *ngIf="loaded && !loadingPage && orders.length"
        (scroll)="isScrolledInfinityView($event)">
    <div class="table-events table-panel multiple-lines desktop-view">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort>
            <ng-container matColumnDef="num_ticket">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-receipt th-icon"></i> Nº ticket</b></th>
                <td mat-cell *matCellDef="let o" (click)="openDetail(o)">
                    <span class="link-titulo" *ngIf="o.num_ticket">{{o.num_ticket}}</span>
                    <span class="no-ticket" *ngIf="!o.num_ticket">Sin emitir</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-user th-icon"></i> Abonado</b></th>
                <td mat-cell *matCellDef="let o" (click)="openDetail(o)">
                    <span class="link-titulo">{{o.season_pass?.user?.name || '—'}}</span>
                    <br>
                    <span class="contact-email">{{o.season_pass?.user?.email}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="season">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-calendar-range th-icon"></i> Temporada</b></th>
                <td mat-cell *matCellDef="let o">
                    <span class="season-chip">{{o.season_pass?.season?.name || '—'}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-tag th-icon"></i> Producto</b></th>
                <td mat-cell *matCellDef="let o">
                    <span class="dates-display">{{o.product?.name || '—'}}</span>
                    <span class="qty-badge" *ngIf="o.quantity > 1">×{{o.quantity}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><b><i class="fal fa-calendar th-icon"></i> Fecha</b></th>
                <td mat-cell *matCellDef="let o">
                    <span class="dates-display">{{o.created_at | date:'dd/MM/yyyy HH:mm'}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><b><i class="fal fa-euro-sign th-icon"></i> Importe</b></th>
                <td mat-cell *matCellDef="let o">
                    <span class="amount-display">{{o.total | number: '1.2-2'}} €</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-signal-bars th-icon"></i> Estado</b></th>
                <td mat-cell *matCellDef="let o">
                    <span class="status-badge" [ngClass]="getStatusBadgeClass(o)">
                        <i class="fa-solid" [ngClass]="getStatusIcon(o)"></i>
                        {{o.status?.name}}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable-row" (click)="openDetail(row)"></tr>
        </table>
    </div>

        <!-- Vista de tarjetas para móvil: los mismos pedidos que la tabla, uno por
             tarjeta. Va dentro de #containerScroll para que el scroll infinito
             siga funcionando aquí igual que con la tabla. -->
        <div class="mobile-view list-cards">
            <div class="list-card" *ngFor="let o of orders" (click)="openDetail(o)">
                <div class="card-top">
                    <p class="card-title">{{o.season_pass?.user?.name || '—'}}</p>
                    <span class="amount-display card-amount">{{o.total | number: '1.2-2'}} €</span>
                </div>

                <div class="card-rows">
                    <div class="card-row">
                        <i class="fal fa-receipt"></i>
                        <span class="card-row-value" *ngIf="o.num_ticket">{{o.num_ticket}}</span>
                        <span class="no-ticket" *ngIf="!o.num_ticket">Sin emitir</span>
                    </div>
                    <div class="card-row" *ngIf="o.season_pass?.user?.email">
                        <i class="fal fa-envelope"></i>
                        <span class="card-row-value card-row-muted">{{o.season_pass.user.email}}</span>
                    </div>
                    <div class="card-row">
                        <i class="fal fa-tag"></i>
                        <span class="card-row-value">
                            {{o.product?.name || '—'}}
                            <span class="qty-badge" *ngIf="o.quantity > 1">×{{o.quantity}}</span>
                        </span>
                    </div>
                    <div class="card-row">
                        <i class="fal fa-calendar"></i>
                        <span class="card-row-value card-row-muted">{{o.created_at | date:'dd/MM/yyyy HH:mm'}}</span>
                    </div>
                </div>

                <div class="card-foot">
                    <span class="status-badge" [ngClass]="getStatusBadgeClass(o)">
                        <i class="fa-solid" [ngClass]="getStatusIcon(o)"></i>
                        {{o.status?.name}}
                    </span>
                    <span class="season-chip">{{o.season_pass?.season?.name || '—'}}</span>
                </div>
            </div>
        </div>

        <div class="pagination-component">
            <div class="d-flex align-items-center pagination-panel pagination-table" *ngIf="!loadingPage && !finishScroll">
                <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
                    containerClass="loading-box"></ng-lottie>
            </div>
        </div>
    </div>

    <div *ngIf="loaded && !loadingPage && orders.length === 0" class="empty-state">
        <i class="fal fa-receipt"></i>
        <p>No hay pedidos</p>
        <span>Aquí aparecerán los pagos de abonos en cuanto se cobre el primero</span>
    </div>
</div>
